import dchAPI from '@/services/dchAPI';
import configService from '@/services/configService';

const state = {
  config: {},
};

const getters = {
  allConfig: (state) => state.config,
};

const actions = {
  async fetchConfig({ commit }, prefetchedResponse) {
    const response = prefetchedResponse || (await dchAPI.get('config'));
    const responseData = transformConfigResponseData(response.data.data);
    commit('setConfigData', responseData);
    return response;
  },
};

const mutations = {
  setConfigData: (state, config) => {
    state.config = config;
  },
};

const transformConfigResponseData = (data) => {
  return {
    outcomes: {
      // Backend now returns endpoints with id, label, description directly
      endpoints: data.outcomes.endpoints,
    },
    available_sources: data.available_sources.map((source) => {
      return {
        ...source,
        ...configService.availableSources().find((s) => s.id === source.source_handle),
      };
    }),
    source_schedule_types: data.source_schedule_types,
  };
};

export default {
  state,
  getters,
  actions,
  mutations,
};
